import { InjectionToken } from '@angular/core';

/** Base URL of the API the application talks to (environment.apiUrl). */
export const GRAY_API_URL = new InjectionToken<string>('GRAY_API_URL');

/**
 * Cookie the access token is stored in. Each application uses its own name so a
 * student session and a coach session never overwrite each other.
 */
export const GRAY_AUTH_COOKIE_NAME = new InjectionToken<string>('GRAY_AUTH_COOKIE_NAME');
